import { InternalUserInfoInput, ParticipantTypes } from "@api/graphql";
import { ValidationErrors } from "@pages/register/hooks/errorResolver";
import { isAmpCmoArtCentre, isArtistBeneficiary } from "@util/index";

export const internalUserInfoErrorResolver = async (
  data: InternalUserInfoInput,
  accountStatus?: string,
  participantTypes?: ParticipantTypes[],
): Promise<{ values: InternalUserInfoInput; errors: ValidationErrors<InternalUserInfoInput> }> => {
  const errors: ValidationErrors<InternalUserInfoInput> = {};

  const isBankHoldMandatory =
    (isAmpCmoArtCentre(participantTypes) && (accountStatus === "ACTIVE" || accountStatus === "PENDING_APPROVAL")) ||
    isArtistBeneficiary(participantTypes); // Always mandatory for Artist/Beneficiary

  if (isBankHoldMandatory && !data.finance_hold) {
    errors.finance_hold = {
      type: "required",
      message: "Bank account hold status is required",
    };
  }

  return {
    values: data,
    errors,
  };
};
